import client from "./client";
import { metaClickIds } from "../lib/metaClickIds";
import { googleClickIds } from "../lib/googleClickIds";

// 15s here only (not on the shared client): long enough for a slow mobile
// network, short enough that a visitor isn't left staring at a dead button
// if the request never settles.
const RESUME_LINK_TIMEOUT_MS = 15000;

export const leadsApi = {
  // The caller's payload wins over the collected click ids: they are context,
  // not content.
  sendResumeLink: (payload) =>
    client.post(
      "/api/leads/resume-link",
      { ...metaClickIds(), ...googleClickIds(), ...payload },
      { timeout: RESUME_LINK_TIMEOUT_MS },
    ),
  resolveResume: (token) =>
    client.get(`/api/leads/resume?t=${encodeURIComponent(token)}`),
};
